import { render, staticRenderFns } from "./ClientFactureList.vue?vue&type=template&id=16571e0e&scoped=true"
import script from "./ClientFactureList.vue?vue&type=script&lang=js"
export * from "./ClientFactureList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16571e0e",
  null
  
)

export default component.exports